import SearchCompetitorsWidgetFilters from "./SearchCompetitorsWidgetFilters";
import { organicSearchTypes as searchTypes } from "app/common/keyword-research/search-competitors/searchTypeConsts";

const OrganicSearchCompetitorsWidgetFilters: any = (props) => {
    return (
        <SearchCompetitorsWidgetFilters
            {...props}
            searchTypes={searchTypes}
        />
    );
};

export default OrganicSearchCompetitorsWidgetFilters;
